import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import BookAppointmentDrawer from "../BookAppointmentDrawer"
import CalendarDrawer from "../CalendarDrawer"
import PatientDiagnosisDrawer from "../PatientDiagnosisDrawer"
import "./EmptyRightDrawer.scss"

function EmptyRightDrawer(props: any) {
  const component = useSelector((state: any) => state.drawer?.componentData)

  function renderChildren() {
    if (component) {
      if (component?.name === "PatientDiagnosisDrawer") {
        return <PatientDiagnosisDrawer patientId={component?.data?.patientId} isReadOnly={component?.data?.isReadOnly}
        />
      } else if (component?.name === "CalendarDrawer") {
        return <CalendarDrawer />
      } else if (component?.name === "BookAppointmentDrawer") {
        return (
          <BookAppointmentDrawer
            upcomingAppointments={component?.data?.upcomingAppointments}
          />
        )
      }
    } else if (props.children) {
      return props.children
    } else return null
  }

  return (
    <div className="right-drawer">
      <div className="appointment-summary-panel">
        <div className="close-sidebar">
          <div className="close-btn cursor-pointer" onClick={() => props?.onClose()}>
            <img
              src="../../assets/images/close-icon.svg"
              height="14px"
              width="14px"
              alt=""
            />
          </div>
        </div>
        <div className="children-wrapper">{renderChildren()}</div>
      </div>
    </div >
  )
}

export default EmptyRightDrawer
